import "./index.scss?id=20230925-1";

import { Box, Stack } from "@mui/material";
import ScreenLoader from "components/ScreenLoader";
import VersionLabel from "components/Version";
import { ADMIN_USER_TYPE } from "constants/index";
import { getSupportsCoachApproach } from "modules/facility-options/facilityOptionsServices";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

import navbarData from "./navbarData";
import NavbarItem from "./NavbarItem";

interface NavbarProps {
  messageBadge?: number;
}

const Navbar = (props: NavbarProps) => {
  const { messageBadge } = props;

  const [activeItem, setActiveItem] = useState(navbarData[0]);
  const location = useLocation();
  const authUser = useAppSelector((state) => state.auth.authUser);
  const pathname = "/" + location.pathname.split("/")[1];
  const [flagLoaded, setFlagLoaded] = useState(false);
  const [supportsCoachApproach, setSupportsCoachApproach] = useState(false);
  const [loading, setLoading] = useState(true);

  const getSupportsCoachApproachFlag = async () => {
    setLoading(true);
    try {
      let result = await getSupportsCoachApproach();
      setSupportsCoachApproach(result);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      return false;
    }
  };

  useEffect(() => {
    if (flagLoaded === false) {
      setFlagLoaded(true);
      getSupportsCoachApproachFlag().then((flag) => setSupportsCoachApproach(flag));
    }
  }, [flagLoaded, supportsCoachApproach, loading]);

  const navbarDisplayData = useMemo(() => {
    let filteredNavBar =
      authUser?.user?.bytType === ADMIN_USER_TYPE
        ? [...navbarData]
        : [...navbarData].filter((f) => !f.isOnlyAccessibleByAdmin);
    filteredNavBar =
      supportsCoachApproach === true
        ? [...filteredNavBar]
        : [...filteredNavBar].filter((f) => !f.isOnlyAccessibleByTCA);

    // Set the unread message count badge next to the Message Center menu option
    if (messageBadge > 0) {
      let newMessageRoute = [...filteredNavBar];
      let messageIndex = -1;
      filteredNavBar.forEach((entry, index, filteredNavBar) => {
        if (entry["link"] === "/message-center") {
          messageIndex = index;
        }
      });
      filteredNavBar[messageIndex].badge = messageBadge;

      return newMessageRoute;
    }

    return filteredNavBar;
  }, [messageBadge, [loading]]);

  useEffect(() => {
    if (activeItem.link !== pathname) {
      const newActiveItem = navbarData.find((item) => item.link === pathname);

      if (newActiveItem) {
        setActiveItem(newActiveItem);
      }
    }
  }, [pathname, activeItem.link]);

  return loading ? (
    <ScreenLoader isScreenLoader />
  ) : (
    <div>
      <nav className="navbar-list">
        {navbarDisplayData.map((navItem, index) => {
          return (
            <NavbarItem
              key={index}
              navItem={navItem}
              setActiveItem={setActiveItem}
              activeItem={activeItem}
            />
          );
        })}
      </nav>
      <VersionLabel />
    </div>
  );
};

export default Navbar;
